import { useEffect, useRef, useState } from 'react';

export default function useInterval(
  callback: () => void,
  delay: number | null,
): [undefined | NodeJS.Timeout, (id: NodeJS.Timeout) => void] {
  const [id, setId] = useState<undefined | NodeJS.Timeout>();
  const savedCallback = useRef<() => void>(callback);
  const clear = (idTmp: NodeJS.Timeout) => clearInterval(idTmp);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      setId(setInterval(tick, delay));
    }

    return () => {
      clearInterval(id);
    };
  }, [delay]);
  return [id, clear];
}
